// Whose collection an auth snapshot is. Pure, in its own module, so every
// collection layer (write fence, per-copy client, capability and Retry stores)
// applies the SAME rule even where a test replaces the auth store module.

export interface AuthSnapshotLike {
  userId: string | null
  loading: boolean
  /** The session is a Supabase ANONYMOUS user. Absent reads as false. */
  anonymous?: boolean
}

/**
 * The permanent user's id, null for a guest (signed out or an anonymous
 * session), undefined while still loading.
 */
export function collectionOwnerOf(s: AuthSnapshotLike): string | null | undefined {
  if (s.loading) return undefined
  if (!s.userId || s.anonymous) return null
  return s.userId
}
